module.exports = __webpack_public_path__ + "static/media/import.27448695.svg";